import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { TicketingSystemLogo } from "./TicketingSystemLogo"

import type { TicketingSystemOptionProps } from "./TicketingSystemLogo.types"

export const TicketingSystemOption = (props: TicketingSystemOptionProps) => {
  const { system, label } = props
  const { t } = useTranslation("translation", { keyPrefix: "ticketing" })

  return (
    <Flex gap={8} align="center">
      <TicketingSystemLogo system={system} className="sm-text-ks" />
      <Text>{label ?? t(`systems.${system}`)}</Text>
    </Flex>
  )
}
